import { render, staticRenderFns } from "./SpeakerDetailView.vue?vue&type=template&id=396bbb7f"
import script from "./SpeakerDetailView.vue?vue&type=script&lang=js"
export * from "./SpeakerDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports